import { Button, Divider, message, Modal, Select, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FaShopify } from "react-icons/fa";
import gql from "../../api/gql";
const CloneToShopify = ({ currentUser, id }) => {
  const { Option } = Select;
  const [status, setStatus] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [data, setData] = useState([]);
  const [site, setSite] = useState("");

  useEffect(() => {
    const roles = currentUser.roles.map((e) => {
      return e.name;
    });

    const findAdmin = roles.find((e) => e === "Administrator");

    if (findAdmin) {
      setStatus(true);
    } else {
      const findSeller = roles.find((e) => e === "Seller");
      if (findSeller) {
        setStatus(true);
      } else {
        setStatus(false);
      }
    }
  }, []);

  const showModal = async () => {
    setLoading(true);
    const seller = currentUser.roles.find((role) => role.name === "Seller");
    const query = `query sites($filter: SiteFilter){
      sites(filter: $filter){
        hits{
          id
          title
          platform
          domain
        }
      }
    }`;

    gql
      .request(query, {
        filter: seller
          ? {
              user_id: currentUser.id,
            }
          : {},
      })
      .then((res) => {
        setData((res.sites.hits || []).filter((e) => e.platform === "shopify"));
        setLoading(false);
        setVisible(true);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleOk = () => {
    setLoadingSubmit(true);
    const q = `mutation moveProductToShopify(
        $site_id: Int!,
        $product_id: Int!,
        $origin_id: String,
        $domain: String
    ){
      moveProductToShopify(
        site_id: $site_id,
        product_id: $product_id,
        origin_id: $origin_id,
        domain: $domain
      )
    }`;
    const findSite = data.find((e) => e.id === site);
    gql
      .request(q, {
        site_id: site,
        product_id: id,
        origin_id: "1",
        domain: findSite.domain,
      })
      .then((res) => {
        message.success("Success");
        setLoadingSubmit(false);
        setVisible(false);
      })
      .catch(() => {
        message.error("Failure");
        setLoadingSubmit(false);
      });
  };

  return (
    <>
      <Modal
        title="Select Store Shopify"
        visible={visible}
        onOk={handleOk}
        onCancel={() => setVisible(false)}
        confirmLoading={loadingSubmit}
        okButtonProps={{ disabled: !site }}
      >
        <Spin spinning={loading} tip="Loading...">
          <Select style={{ width: "100%" }} onChange={setSite}>
            {data.map((e, index) => (
              <Option key={index} value={e.id}>
                {e.title}
              </Option>
            ))}
          </Select>
        </Spin>
      </Modal>
      {status && (
        <>
          <Tooltip title="Push to Shopify">
            <Button onClick={showModal} size="small">
              <FaShopify />
            </Button>
          </Tooltip>
          <Divider type="vertical" />
        </>
      )}
    </>
  );
};

export default CloneToShopify;
